import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import Game from "../../src/shell/Game";
import { chris } from "../characters/Chris";
import { emily } from "../characters/Emily";
import { kim } from "../characters/Kim";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doImageShake, doTransition, doWaitImageByTime, isAgreedToChrisProposal, isAnnGF, isDatingJenny, isFollowingVanessaLead, isJoeEnemy, isMCCheatedWithMerry } from "../helpers/helpers";
import { V9VanessaMCChrisBarAfter } from "./V9";
import { empty } from "../characters/empty";
import { endReplay } from "../../src/shell/endReplay";
import { ScenesReplay } from "../../src/components/menu/Scenes/replayScenes/ScenesReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";



const v9 = images.v9;
export const V9VanessaMCChrisBar = async (): Promise<any> => {
    doTransition(images.v9.V9BarMorning_0);
    mc.think(`Here we are.`);

    ImageClass.setImage(images.v9.V9BarMorning_2);
    chris.talk(`Yo ${mc.name}! What's up?`, { style: { overlay: true } });
    ImageClass.setImage(images.v9.V9BarMorning_33);
    mc.talk(`I'm great, what about you?`);
    ImageClass.setImage(images.v9.V9BarMorning_2);
    chris.talk(`Same!`);
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {
        ImageClass.setImage(images.v9.V9BarMorning_3);
        chris.talk(`Hey Vanessa.`);
        ImageClass.setImage(images.v9.V9BarMorning_4);
        vanessa.talk(`Hey honey.`);
    }

    if (isAgreedToChrisProposal()) {
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`I'm here where is the girl?`);
        ImageClass.setImage(images.v9.V9BarMorning_16);
        chris.talk(`Mmm...`);
        chris.talk(`Maybe we should go somewhere more private?`);
        ImageClass.setImage(images.v9.V9BarMorning_18);
        mc.talk(`Why? What's wrong?`);
        if (Question.globalAnswers.v2AgreeToSeeBJPic) {
            vanessa.talk(`Don't start to be shy on me!`);
        } else {
            vanessa.talk(`Are you shy?`);

        }
        ImageClass.setImage(images.v9.V9BarMorning_17);
        mc.talk(`It's fine... You can talk in front of her.`);
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`I'll just say it how it is then.`);
        chris.talk(`It's regarding our agreement.`);
        chris.talk(`I know Merry was a bit hard to swallow.`);
        // The correct name is did anything sexual with Merry, not just checking for cheating.
        if (isMCCheatedWithMerry()) {
            chris.talk(`Even though you still jumped on that opportunity Haha.`);
        } else {

        }
        chris.talk(`So I wanted to make it up to you.`);
        doWaitImageByTime(v9.V9BarMorning_11);
        chris.talk(`See the girl over there.`);
        chris.talk(`I won't lie. I don't know her at all.`);
        doWaitImageByTime(v9.V9BarMorning_10);
        chris.talk(`She just came here, I told her we are closed but she asked if she can just sit and hang out, and that's it.`);
        chris.talk(`Feel free to introduce yourself to her. She is pretty friendly!`);
        ImageClass.setImage(images.v9.V9BarMorning_5);
        chris.talk(`It's your call!`);
        if (Question.globalAnswers.v1EnableNTR) {
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`Also, it's time for you to throw me a bone!`);
            ImageClass.setImage(images.v9.V9BarMorning_16);
            chris.talk(`It's been dry season for me lately.`);
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`I'm sick of all my girls. I need something new.`);
            mc.think(`I knew I had to give him someone sooner or later.`);
            mc.think(`Better get over it.`);

            ImageClass.setImage(images.v9.V9BarMorning_15);
            await mc.setQuestion(new Question({ text: `I have a girl for you...`, options: { think: false }, key: `v9VanessaMCChrisBarChoseGirlForChrisAgreement` })
                .option({ title: `Ann`, key: `ann`, show: isAnnGF(), hide: Question.globalAnswers.V8AnnDateMCOkWithChris === false })
                .option({ title: `Vanessa`, key: `vanessa` })
                .option({ title: `Alex`, key: `alex` })
                .option({ title: `Emily`, key: `emily` })
                .option({ title: `Jenny`, key: `jenny`, show: isDatingJenny() }));

            return jump(V9VanessaMCChrisBar_GirlsForChrisDialogues, "V9VanessaMCChrisBar_GirlsForChrisDialogues");


        }

        ImageClass.setImage(images.v9.V9BarMorning_5);
        chris.talk(`Have fun!`);
        await ChrisJobProposal();


    } else {
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`Thank you for coming here! I'd like to ask you for a favor and I didn't know who to call.`);
        chris.talk(`Would you mind making sure everything is fine while I do stuff out back?`);
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Sure... I'm already here.`);
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`See the girl over there.`);
        doWaitImageByTime(v9.V9BarMorning_11);
        chris.talk(`I won't lie. I don't know her at all.`);
        doWaitImageByTime(v9.V9BarMorning_10);
        chris.talk(`She just came here, I told her we are closed but she asked if she can just sit and hang out, and that's it.`);
        chris.talk(`Feel free to introduce yourself to her. She is pretty friendly!`);
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Why didn't you ask her to watch your bar?`);
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`Haha, I need someone that can take care of shit if something happens.`);
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Gotcha.`);
        if (isAgreedToChrisProposal() === undefined) {
            ImageClass.setImage(images.v9.V9BarMorning_16);
            chris.talk(`I also have an interesting proposal to make, but we'll do it some other time...`);
            mc.talk(`Sure.`);
        }
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`Thanks man!`);

        await ChrisJobProposal();
    }


    return jump(V9VanessaMCChrisBar_2, "V9VanessaMCChrisBar_2");
};




export const V9VanessaMCChrisBar_GirlsForChrisDialogues = async (): Promise<any> => {
    if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "ann") {
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Ann.`);
        if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`Hmm...`);
            chris.talk(`I don't want to sound like a jerk... But I'm already hooking up with her.`);
            ImageClass.setImage(images.v9.V9BarMorning_15);
            mc.talk(`I'm the reason you know her in the first place so I can credit her to myself.`);
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`Damn. I guess that's fair.`);
            chris.talk(`Haha. Fine, you won this time.`);


        } else if (Question.globalAnswers.V8AnnDateMCOkWithChris === false) {
            chris.talk(`That's strange.`);
            ImageClass.setImage(images.v9.V9BarMorning_15);
            mc.talk(`What is?`);
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`I was sure you told her to stop seeing me...`);
            ImageClass.setImage(images.v9.V9BarMorning_15);
            mc.talk(`I guess I changed my mind.`);
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`So, that means I can hook up with her again?`);
            ImageClass.setImage(images.v9.V9BarMorning_15);
            mc.talk(`Yeah.`);
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`I'll take that!`);
        }




    } else if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "vanessa") {
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Vanessa.`);
        ImageClass.setImage(images.v9.V9BarMorning_27);
        vanessa.talk(`Yo!`);
        ImageClass.setImage(images.v9.V9BarMorning_28);
        vanessa.talk(`Why do you think you have the right to pimp me out like that?`);
        ImageClass.setImage(images.v9.V9BarMorning_29);
        mc.talk(`We both know you don't have a problem with that.`);
        ImageClass.setImage(images.v9.V9BarMorning_28);
        vanessa.talk(`Of course I don't.`);
        mc.talk(`...`);
        if (Question.globalAnswers.v2AgreeToSeeBJPic) {
            mc.talk(`You already sucked his dick so I don't see the big deal.`);
            ImageClass.setImage(images.v9.V9BarMorning_27);
            vanessa.talk(`You know what?`);
            ImageClass.setImage(images.v9.V9BarMorning_30);
            vanessa.talk(`Now that I think about that again it does sound like a good idea.`);
        } else {
            mc.talk(`Vanessa...`);
        }
        if (isFollowingVanessaLead()) {
            vanessa.talk(`I think you got it all wrong! It's me supposed to pimp you out?`);
            chris.talk(`What are you guys talking about?`);

        } else {
            if (Question.globalAnswers.v8VanessaNightFingeredHer !== undefined) {
                mc.talk(`We both know you are dying for that.`);
                vanessa.talk(`Even so! I can't just show it!`);
                mc.talk(`But I'm literally giving you a pass.`);
                vanessa.talk(`You can't blame me for thinking you are just fucking with me.`);

            } else {
                mc.talk(`Since when you are refusing for some sexy time.`);
                vanessa.talk(`Since I'm trying to get more out of that.`);

            }

        }
        ImageClass.setImage(images.v9.V9BarMorning_29);
        mc.talk(`Now it's me starting to have second thoughts.`);
        ImageClass.setImage(images.v9.V9BarMorning_31);
        vanessa.talk(`Don't!`);
        vanessa.talk(`It's actually a great idea.`);

        ImageClass.setImage(images.v9.V9BarMorning_29);
        mc.talk(`Chris? What do you say?`);
        ImageClass.setImage(images.v9.V9BarMorning_32);
        chris.talk(`I'll take that!`);


    } else if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "alex") {
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Alex.`);
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`Alex? who's that?`);
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`A girl I know...`);
        if (Question.globalAnswers.v4ShowedChrisAlexsInsta) {
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`Wait! Is that the girl you showed me her Insta?`);
            ImageClass.setImage(images.v9.V9BarMorning_15);
            mc.talk(`Oh yeah.... I completely forgot about that.`);
            mc.talk(`That's the one.`);

        } else {
            ImageClass.setImage(images.v9.V9BarMorning_2);
            chris.talk(`Is she hot?`);
            ImageClass.setImage(images.v9.V9BarMorning_15);
            mc.talk(`Trust me on that one.`);
        }


    } else if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "jenny") {
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Jenny.`);
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`Jenny? who's that?`);
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`A girl I know...`);
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`Know well enough to hook her up with me?`);
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Trust me.`);
        mc.talk(`She can squeeze your head with her boobs.`);



        // This is else if and not else so it would be easier to see who the dialogue is about.
    } else if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "emily") {
        if (isJoeEnemy()) {
            mc.think(`That can be a good way to get Joe off Emily's back...`);
            mc.think(`No way he can compete with Chris...`);
            mc.think(`I hope it won't come back to bite me in the ass.`);
        }
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`Emily.`);
        ImageClass.setImage(images.v9.V9BarMorning_2);
        chris.talk(`Emily? who's that?`);
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`A very special girl I know.`);
        ImageClass.setImage(images.v9.V9BarMorning_28);
        vanessa.talk(`Isn't she...`);
        mc.talk(`Shh...`);
        ImageClass.setImage(images.v9.V9BarMorning_32);
        chris.talk(`What? Is there something I should know?`);

        ImageClass.setImage(images.v9.V9BarMorning_29);
        mc.talk(`Nope.`);
        ImageClass.setImage(images.v9.V9BarMorning_5);
        chris.talk(`Are you sure...?`);
        ImageClass.setImage(images.v9.V9BarMorning_33);
        mc.talk(`Trust me. She is the most beautiful sexy girl I can hook you up with.`);
        ImageClass.setImage(images.v9.V9BarMorning_31);
        vanessa.talk(`I can vouch for that!`);
        ImageClass.setImage(images.v9.V9BarMorning_28);
        vanessa.talk(`And also a bit jealous!`);
        ImageClass.setImage(images.v9.V9BarMorning_15);
        mc.talk(`What do you say?`);


    }

    if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "jenny" || Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "alex" || Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "emily") {

        ImageClass.setImage(images.v9.V9BarMorning_5);
        chris.talk(`DEAL!`);
        chris.talk(`When are you going to introduce me to her?`);
        ImageClass.setImage(images.v9.V9BarMorning_33);
        mc.talk(`I'll think of something and contact you.`);
        ImageClass.setImage(images.v9.V9BarMorning_5);
        chris.talk(`I trust you bro!`);
    }
    await ChrisJobProposal();





    return jump(V9VanessaMCChrisBar_GirlsForChrisDialogues_ChrisLeft, "V9VanessaMCChrisBar_GirlsForChrisDialogues_ChrisLeft");
};
function ChrisJobProposal() {
    ImageClass.setImage(images.v9.V9BarMorning_5);
    chris.talk(`Oh! One last thing.`);
    chris.talk(`If you come across by someone that needs a job let me know.`);
    ImageClass.setImage(images.v9.V9BarMorning_33);
    mc.talk(`What are the requirements?`);
    ImageClass.setImage(images.v9.V9BarMorning_5);
    chris.talk(`Someone that is not a complete idiot...`);
    chris.talk(`Preferably a female.`);
    if (!Question.globalAnswers.v1EnableNTR) {
        chris.talk(`And don't get your mind racing! This is going to be completely professional and we'll have no contact.`);
        chris.talk(`She'll be here when I'm not.`);
        chris.talk(`The business just tend to be better with a female working the bar.`);
    }
    ImageClass.setImage(images.v9.V9BarMorning_33);
    mc.talk(`Sure... I'll keep an eye out.`);
    ImageClass.setImage(images.v9.V9BarMorning_5);
    chris.talk(`Thanks! I'm gonna take care of some stuff at the back.`);
    doWaitImageByTime(v9.V9BarMorning_6);
}
export const V9VanessaMCChrisBar_GirlsForChrisDialogues_ChrisLeft = async (): Promise<any> => {

    empty.think('', { style: { overlay: false }, wait: false });
    if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "ann") {
        doWaitImageByTime(images.v9.V9BarMorning_34);
        vanessa.talk(`${mc.name}. Call my impressed.`);
        mc.talk(`Okay, Impressed.`);
        vanessa.talk(`...`);
        ImageClass.setImage(images.v9.V9BarMorning_21);
        vanessa.talk(`Pimping out your girlfriend like that is really impressive!`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
            mc.talk(`They are already hooking up so I'm not really losing anything.`);
        } else {
            mc.talk(`They already hooked up in the past.`);
        }
        ImageClass.setImage(images.v9.V9BarMorning_20);
        vanessa.talk(`But what if they didn't?`);
        mc.talk(`Let your mind go wild.`);
        ImageClass.setImage(images.v9.V9BarMorning_21);
        vanessa.talk(`Pimp!`);

    } else if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "vanessa") {


    } else if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "alex") {
        doWaitImageByTime(images.v9.V9BarMorning_20);
        vanessa.talk(`I think I know who Alex is!`);
        vanessa.talk(`Isn't that Ann's friend?`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`She is.`);
        ImageClass.setImage(images.v9.V9BarMorning_34);
        vanessa.talk(`And you decide to just hand her over to Chris?`);
        if (isAnnGF()) {
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`You realize I'm Ann's boyfriend, right?`);
            ImageClass.setImage(images.v9.V9BarMorning_20);
            vanessa.talk(`So?`);
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`I should have known...`);
        } else {
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`Yup.`);
            ImageClass.setImage(images.v9.V9BarMorning_34);
            vanessa.talk(`Interesting...`);
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`What?`);
            ImageClass.setImage(images.v9.V9BarMorning_34);
            vanessa.talk(`Nothing!`);
        }


    } else if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "jenny") {
        if (Game.seenScenarios.includes(`V7_JennyJoeRivalBar`)) {
            doWaitImageByTime(images.v9.V9BarMorning_20);
            vanessa.talk(`It just ocurred to me!`);
            ImageClass.setImage(images.v9.V9BarMorning_36);
            vanessa.talk(`Isn't Jenny is that one sneaky Joe went off to date behind my back?`);
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`That's the one.`);
            ImageClass.setImage(images.v9.V9BarMorning_36);
            vanessa.talk(`Fucker!`);
            vanessa.talk(`Yeah. I vouch for this match.`);
            vanessa.talk(`Let Chris fuck her. That will show him!`);
        } else {

        }

    } else if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "emily") {
        doWaitImageByTime(images.v9.V9BarMorning_21);
        vanessa.talk(`I can't believe you are going to pimp out your ${emily.properties.relation} like that!`);
        if (isJoeEnemy()) {
            ImageClass.setImage(images.v9.V9BarMorning_34);
            vanessa.talk(`But I feel like there is something more to it!`);
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`Don't stress your brain too much.`);
            mc.talk(`I just think he is a nice guy and can be a good match for Emily.`);
            ImageClass.setImage(images.v9.V9BarMorning_20);
            vanessa.talk(`Rrrright.`);
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.think(`She is not buying it.`);
            mc.think(`But who cares? What can she do?`);

        } else {
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`What do you mean? Chris is actually a nice guy.`);
        }
        ImageClass.setImage(images.v9.V9BarMorning_20);
        vanessa.talk(`If you say so...`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`You don't think that?`);
        ImageClass.setImage(images.v9.V9BarMorning_34);
        vanessa.talk(`He is fine. But is he really the right choice for Emily...`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`You don't think he is capable of settling in someday?`);
        ImageClass.setImage(images.v9.V9BarMorning_34);
        vanessa.talk(`Maybe... But not soon.`);
        ImageClass.setImage(images.v9.V9BarMorning_20);
        vanessa.talk(`Either way, this should be very very interesting.`);

    }
    return jump(V9VanessaMCChrisBar_2, "V9VanessaMCChrisBar_2");
};

export const V9VanessaMCChrisBar_2 = async (): Promise<any> => {

    // Vanessa Alone.
    if (isFollowingVanessaLead()) {
        doWaitImageByTime(images.v9.V9BarMorning_34);
        vanessa.talk(`Anyway, I'm so glad you brought us here!`);
        vanessa.talk(`So many opportunities!`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`I understand you already have something in mind.`);
        ImageClass.setImage(images.v9.V9BarMorning_20);
        vanessa.talk(`Uh huh!`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`Let's hear it.`);
        if (Question.globalAnswers.v1EnableNTR) {
            ImageClass.setImage(images.v9.V9BarMorning_22);
            vanessa.talk(`So you are going to fuck that girl over there while I go fuck Chris.`);
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`Is that what you managed to come up with?`);
            if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "vanessa") {
                ImageClass.setImage(images.v9.V9BarMorning_20);
                vanessa.talk(`You literally just offered me to him.`);
                ImageClass.setImage(images.v9.V9BarMorning_34);
                vanessa.talk(`So better just get it over with.`);
                ImageClass.setImage(images.v9.V9BarMorning_35);
                mc.talk(`Don't act stupid!\nYou'd suggest the same thing even if I didn't.`);
                ImageClass.setImage(images.v9.V9BarMorning_20);
                vanessa.talk(`Yeah... True...`);
                ImageClass.setImage(images.v9.V9BarMorning_34);
                vanessa.talk(`I still find it a great idea!`);

            } else {
                ImageClass.setImage(images.v9.V9BarMorning_34);
                vanessa.talk(`Well... The star aligned and we have both a male and a female waiting for us to fuck them.`);

            }
            ImageClass.setImage(images.v9.V9BarMorning_20);
            vanessa.talk(`Unless you want to take Chris and I'll take that girl.`);
            mc.talk(`Hell no!`);
            ImageClass.setImage(images.v9.V9BarMorning_34);
            vanessa.talk(`It settles then!`);
            if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy === false) {
                ImageClass.setImage(images.v9.V9BarMorning_36);
                vanessa.talk(`And you better not back off like you did with that girlfriend of that ogre the other day.`);
            }
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`I knew that what it takes to be you.`);
            mc.talk(`You just run around and fuck people.`);
            ImageClass.setImage(images.v9.V9BarMorning_21);
            vanessa.talk(`That's so shallow of you.`);
            vanessa.talk(`Of course there is more.`);
            ImageClass.setImage(images.v9.V9BarMorning_34);
            vanessa.talk(`But you first got to start with the basics.`);
            vanessa.talk(`We won't be able to move forward until you'd do that.`);

            vanessa.talk(`Now. Let's go talk to that girl over there.`);
            vanessa.talk(`I want to make sure you don't fuck this up.`);
            ImageClass.setImage(images.v9.V9BarMorning_20);
            vanessa.talk(`If she is not into it I can't really blame you. Right?`);


        } else {
            ImageClass.setImage(images.v9.V9BarMorning_34);
            vanessa.talk(`You either go fuck that girl over there.`);
            vanessa.talk(`Or we can do it together.`);
            ImageClass.setImage(images.v9.V9BarMorning_35);
            mc.talk(`That is actually doesn't sound like a bad idea...`);
            ImageClass.setImage(images.v9.V9BarMorning_34);
            vanessa.talk(`I know right!`);
            vanessa.talk(`Let's go talk to her!`);

        }

        return jump(v9VanessaMCChrisBar_Kim, "v9VanessaMCChrisBar_Kim");


    }

    if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "vanessa") {
        ImageClass.setImage(images.v9.V9BarMorning_20);
        vanessa.talk(`Is this your big plan?`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`What do you mean?`);
        ImageClass.setImage(images.v9.V9BarMorning_36);
        vanessa.talk(`Distracting me with a penis.`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`Explain.`);
        if (Question.globalAnswers.v9VanessaBusMcLeadingMasturbateMovedSeat) {
            ImageClass.setImage(images.v9.V9BarMorning_37);
            vanessa.talk(`First you made sure to have that stud on the bus sitting in front of me.`);
            ImageClass.setImage(images.v9.V9BarMorning_36);
            vanessa.talk(`And you knew I couldn't resist!`);
            ImageClass.setImage(images.v9.V9BarMorning_37);
            vanessa.talk(`And now Chris?`);
        } else if (Question.globalAnswers.v9VanessaBusMcLeadingMasturbateMovedSeat === false) {
            ImageClass.setImage(images.v9.V9BarMorning_36);
            vanessa.talk(`You planned to made me horny on the bus and than send me over to Chris.`);

        }
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`What can I possibly gain from this?`);
        ImageClass.setImage(images.v9.V9BarMorning_36);
        vanessa.talk(`Distracting me so I'll forget about everything.`);
        vanessa.talk(`How is me putting all the work and you doing nothing is me following you?`);
        ImageClass.setImage(images.v9.V9BarMorning_35);
        mc.talk(`Why do you have to ask so many questions?`);
        mc.talk(`We both know you enjoy this, so why complaining?`);
        ImageClass.setImage(images.v9.V9BarMorning_20);
        vanessa.talk(`Shut up will ya?`);

        ImageClass.setImage(images.v9.V9BarMorning_34);
        vanessa.talk(`So, what now?`);
        vanessa.talk(`Do you want me to go over to Chris and pay your little debt or...?`);

    } else {
        ImageClass.setImage(images.v9.V9BarMorning_34);
        vanessa.talk(`That was fun! Now what?`);
        vanessa.talk(`I know what I'd do... But as you know...`);
        ImageClass.setImage(v9.V9BarMorning_21);
        vanessa.talk(`Little ol' me needs to do as you wish.`);
    }

    ImageClass.setImage(images.v9.V9BarMorning_35);
    mc.talk(`Hmm...`);
    mc.talk(`I don't see too many options here.`);
    mc.talk(`Let's go talk to that girl over there and see what happens.`);
    ImageClass.setImage(images.v9.V9BarMorning_34);
    vanessa.talk(`I'm down!`);


    return jump(v9VanessaMCChrisBar_Kim, "v9VanessaMCChrisBar_Kim");
};

export const v9VanessaMCChrisBar_Kim = async (): Promise<any> => {

    doWaitImageByTime(images.v9.V9BarMorning_24);
    vanessa.talk(`Hey there!`, { style: { overlay: true } });
    ImageClass.setImage(images.v9.V9BarMorning_25);
    kim.talk(`Hey!`);
    ImageClass.setImage(v9.V9BarMorning_38);
    vanessa.talk(`Hey, mind if we join you? It's kinda rare to see anyone else here this early.`);
    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`Hmm... I wouldn't call it early for me.`);
    ImageClass.setImage(v9.V9BarMorning_40);
    kim.talk(`I had a crazy fun night today, or should I say yesterday... Anyway, I just wasn't ready to call it a day.`);
    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`So I decided to stay here for a bit.`);
    ImageClass.setImage(v9.V9BarMorning_23);
    mc.talk(`That Must have been some event to keep you out all night.`);
    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`Haha. Let's just say it was worth the lack of sleep.`);
    ImageClass.setImage(v9.V9BarMorning_23);
    kim.talk(`But enough about me. But brings you two here at this hour?`);
    ImageClass.setImage(v9.V9BarMorning_23);
    mc.talk(`Hmm... Chris the bartender, asked me for a favor to come and watch the bar while he does some work stuff at the back.`);
    mc.talk(`And Vanessa here kinda joined me for no reason.`);
    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`So you are not a couple?`);
    mc.talk(`Nope.`);
    ImageClass.setImage(v9.V9BarMorning_40);
    kim.talk(`I'm Kim by the way.`);
    mc.talk(`${mc.name}.`);

    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`Vanessa, can I ask you something?`);
    ImageClass.setImage(v9.V9BarMorning_38);
    vanessa.talk(`Of course, honey.`);
    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`Do you mind giving ${mc.name} a small kiss?`);
    ImageClass.setImage(v9.V9BarMorning_41);
    vanessa.talk(`Woah. Where did that come from?`);
    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`Haha, excuse me. I'm still in my goofy mood from last night.`);
    kim.talk(`It's okay you don't have to do that if that's too much.`);
    ImageClass.setImage(v9.V9BarMorning_24);
    vanessa.talk(`Do you think I'm one of those shy girls?`);
    vanessa.talk(`I'll raise the stakes and suck his cock right now!`);
    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`Haha... No. We don't have to go that far.`);
    kim.talk(`Kiss would have been enough but forget about that.`);
    ImageClass.setImage(v9.V9BarMorning_24);
    vanessa.talk(`Are you serious with me right now?`);
    vanessa.talk(`Do you always go around asking people to kiss each others.`);
    ImageClass.setImage(v9.V9BarMorning_39);
    kim.talk(`Only if they approach at bars when there are no one else around.`);
    ImageClass.setImage(v9.V9BarMorning_26);
    vanessa.talk(`Can you hold on for a second? I just remembered that I forgot something in the car!`);
    mc.think(`Car? We came here via bus.`);

    // alone with Kim
    doWaitImageByTime(v9.V9BarMorning_12);
    mc.talk(`I think you scared her.`);
    ImageClass.setImage(v9.V9BarMorning_57);
    kim.talk(`Haha, sorry, I didn't realize she is that shy.`);
    ImageClass.setImage(v9.V9BarMorning_12);
    mc.talk(`Oh, trust me. She is far away from that.`);
    ImageClass.setImage(v9.V9BarMorning_13);
    kim.talk(`So she just likes you very much.`);
    ImageClass.setImage(v9.V9BarMorning_12);
    mc.talk(`What makes you say that?`);
    ImageClass.setImage(v9.V9BarMorning_13);
    kim.talk(`Why wouldn't she want to kiss you than?`);
    ImageClass.setImage(v9.V9BarMorning_12);
    mc.talk(`There is so much I need to explain before it would start to making sense...`);
    ImageClass.setImage(v9.V9BarMorning_13);
    kim.talk(`I see.`);
    kim.talk(`Excuse me for a minute please.`);
    ImageClass.setImage(v9.V9BarMorning_12);
    mc.talk(`Of course.`);
    doWaitImageByTime(v9.V9BarMorning_44);
    mc.think(`...`);
    doWaitImageByTime(v9.V9BarMorning_46);
    vanessa.talk(`Finally the crazy lady left.`, { style: { overlay: true } });
    ImageClass.setImage(v9.V9BarMorning_47);
    mc.talk(`Crazy? Why? Because she asked you to give me a kiss?`);
    ImageClass.setImage(v9.V9BarMorning_50);
    vanessa.talk(`Duh!`);
    ImageClass.setImage(v9.V9BarMorning_49);
    mc.talk(`My curiosity senses are tingling. What's the big deal about you and kissing?`);
    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`Big deal? Why do you think it's a big deal?`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`You seemed scared when she told you to kiss me.`);
    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`I don't just kiss anyone.`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`You know... That's very interesting.`);
    mc.talk(`You are willing to fuck around anyone, anywhere, but not kissing.`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`What can I say? I have standards.`);
    ImageClass.setImage(images.v9.V9BarMorning_43);
    mc.talk(`I see...`);

    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`By the way, she is totally wants to fuck you.`);
    ImageClass.setImage(images.v9.V9BarMorning_43);
    mc.talk(`What makes you say that?`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`If it wasn't obvious from the conversation. She was supposed to be back by now.`);
    vanessa.talk(`She is definitely waiting for you in the bathroom.`);
    ImageClass.setImage(images.v9.V9BarMorning_43);
    mc.talk(`She said she was partying, maybe it's all coming back up.`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`No way. She sat here for a while and didn't show any signs of that.`);
    ImageClass.setImage(images.v9.V9BarMorning_46);
    vanessa.talk(`And stop being annoying! I know what I'm saying. I know my bitches.`);




    if (isFollowingVanessaLead()) {
        ImageClass.setImage(images.v9.V9BarMorning_42);
        vanessa.talk(`You know what? It's just the perfect opportunity!`);
        vanessa.talk(`You go check up on her!`);

        if (Question.globalAnswers.v1EnableNTR) {
            ImageClass.setImage(images.v9.V9BarMorning_42);
            vanessa.talk(`And I'll go see what Chris is up to.`);
            ImageClass.setImage(images.v9.V9BarMorning_46);
            vanessa.talk(`Oh and one last thing!`);
            if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy) {
                vanessa.talk(`Don't you dare chicken out.`);

            } else if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy === false) {
                vanessa.talk(`Don't you dare chicken out again!`);
            }
            ImageClass.setImage(images.v9.V9BarMorning_42);
            vanessa.talk(`If you do. I'll punish you!`);
            vanessa.talk(`Good luck!`);
            ImageClass.setImage(v9.V9BarMorning_44);
            mc.think(`Punish me? I have no idea what she means by that.`);
            mc.think(`But I do know she is crazy so I should consider my steps very carefully.`);
            await mc.setQuestion(new Question({ text: `Should I listen to her or...`, options: { think: true }, key: `v9VanessaMCChrisBarWatchedVanessaChris` })
                .option({ title: `Go Watch Vanessa with Chris`, key: true })
                .option({ title: `Meet Kim at the restroom`, key: false }));


            if (Question.globalAnswers.v9VanessaMCChrisBarWatchedVanessaChris) {
                return jump(V9VanessaMCChrisBarVanessaWithChris, "V9VanessaMCChrisBarVanessaWithChris");
            }
            return jump(V9VanessaMCChrisBarJoinKim, "V9VanessaMCChrisBarJoinKim");


        } else {
            ImageClass.setImage(v9.V9BarMorning_42);
            vanessa.talk(`I'll join in a few.`);
            ImageClass.setImage(v9.V9BarMorning_43);
            vanessa.talk(`I want to see if you can handle her by yourself first.`);
            mc.talk(`I'm fine with that.`);
            ImageClass.setImage(v9.V9BarMorning_42);
            vanessa.talk(`So go! What are you waiting for?`);
            return jump(V9VanessaMCChrisBarJoinKim, "V9VanessaMCChrisBarJoinKim");
        }
    } else {
        ImageClass.setImage(images.v9.V9BarMorning_42);
        vanessa.talk(`I bet that you'd thank me if you go check up on her in the bathroom.`);
        ImageClass.setImage(images.v9.V9BarMorning_43);
        vanessa.talk(`You know, just to see that everything is fine.`);
        mc.talk(`I might just do that.`);
        ImageClass.setImage(v9.V9BarMorning_45);
        vanessa.talk(`But wait! Don't forget about me!`);
        vanessa.talk(`What do you want me to do now master?`);
        mc.think(`Oh... this again.`);
        await mc.setQuestion(new Question({ text: `Second. Let me think.`, options: { think: false }, key: `v9VanessaMCChrisBarMCLeadingOptions` })
            .option({ title: `Send Vanessa To Chris`, key: `sendVanessaToChris`, show: Question.globalAnswers.v1EnableNTR })
            .option({ title: `Check up on Kim alone`, key: `fuckKimAlone` })
            .option({ title: `Check up on Kim together`, key: `funWithKimTogether` })
            .option({ title: `Just Sit And Talk`, key: `sitAndTalk` }));


        if (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "sendVanessaToChris") {
            mc.talk(`You should go and see if Chris needs a hand... Or two.`);
            ImageClass.setImage(v9.V9BarMorning_42);
            vanessa.talk(`Really??? I knew I can count on you!`);
            vanessa.talk(`I'll go over there right now before you change your mind!`);
            doWaitImageByTime(v9.V9BarMorning_44);
            await mc.setQuestion(new Question({ text: `Vanessa left... Now what?`, options: { think: true }, key: `v9VanessaMCChrisBarOptionsVanessaWithChrisOptions` })
                .option({ title: `Go Watch Vanessa with Chris`, key: "watchVanessaNChris" })
                .option({ title: `Meet Kim at the restroom`, key: "fuckKimAlone" })
                .option({ title: `Sit and wait for Vanessa`, key: "sitAndWait" }));


            if (Question.globalAnswers.v9VanessaMCChrisBarOptionsVanessaWithChrisOptions === "watchVanessaNChris") {
                return jump(V9VanessaMCChrisBarVanessaWithChris, "V9VanessaMCChrisBarVanessaWithChris");

            } else if (Question.globalAnswers.v9VanessaMCChrisBarOptionsVanessaWithChrisOptions === "fuckKimAlone") {
                return jump(V9VanessaMCChrisBarJoinKim, "V9VanessaMCChrisBarJoinKim");

            }

            return jump(V9VanessaMCChrisBar_WaitForVanessa, "V9VanessaMCChrisBar_WaitForVanessa");


        } else if (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "funWithKimTogether") {
            mc.talk(`If I do this. I want you to come as well.`);
            mc.talk(`I'm not planning to spend the night in jail by myself if you are wrong.`);
            ImageClass.setImage(v9.V9BarMorning_42);
            vanessa.talk(`Great idea!`);
            vanessa.talk(`I'll give you a few minutes to warm her up before jumping in.`);
            ImageClass.setImage(v9.V9BarMorning_43);
            mc.talk(`You are so sure of yourself...`);
            ImageClass.setImage(v9.V9BarMorning_48);
            vanessa.talk(`Just go before she changes her mind!`);

            return jump(V9VanessaMCChrisBarJoinKim, "V9VanessaMCChrisBarJoinKim");

        } else if (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "fuckKimAlone") {
            mc.talk(`I'll go meet her in the restroom.`);
            ImageClass.setImage(v9.V9BarMorning_42);
            vanessa.talk(`Great idea!`);
            ImageClass.setImage(v9.V9BarMorning_46);
            vanessa.talk(`Wait...`);
            vanessa.talk(`What about me?`);
            ImageClass.setImage(v9.V9BarMorning_47);
            mc.talk(`Chris clearly asked that someone watch the bar.`);
            mc.talk(`That's where you come in.`);
            ImageClass.setImage(v9.V9BarMorning_48);
            vanessa.talk(`Fucker! Are you serious?`);
            mc.talk(`Make sure no one steals anything!`);

            return jump(V9VanessaMCChrisBarJoinKim, "V9VanessaMCChrisBarJoinKim");
        }
        return jump(V9VanessaMCChrisBarSitTalk, "V9VanessaMCChrisBarSitTalk");
    }




};

export const V9VanessaMCChrisBarVanessaWithChris = async (): Promise<any> => {
    doTransition(v9.V9VanessaChrisBehindBar_3);

    mc.think(`They got into it right away!`, { style: { overlay: false } });
    mc.think(`She's sucking his dick in broad day light.`);
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_8);
    mc.think(`And she doesn't care if someone sees her.`);
    mc.think(`Why should she? He is taking pictures for people who might miss it...`);


    ImageClass.setImage(v9.V9VanessaChrisBehindBar_25);
    mc.think(`I've been seen... There is no point standing this far away now.`);
    ImageClass.setImage(v9.V9VanessaChrisBehindBar_26);
    chris.talk(`Hey bro! Wanna join?`);
    vanessa.talk(`Mump!`);
    chris.talk(`Is that a yes?`);
    ImageClass.setImage(v9.V9VanessaChrisBehindBar_27);
    vanessa.talk(`No! He was supposed to fuck the girl at the bar!`);
    ImageClass.setImage(v9.V9VanessaChrisBehindBar_10);
    vanessa.talk(`He should get a punishment not a reward!`);

    ImageClass.setImage(v9.V9VanessaChrisBehindBar_28);
    chris.talk(`Damn...`);
    ImageClass.setImage(v9.V9VanessaChrisBehindBar_29);
    vanessa.talk(`He can help you with those pictures you are taking it's making you lose concentration.`);
    chris.talk(`Yeah... You are probably right.`);

    ImageClass.setImage(v9.V9VanessaChrisBehindBar_11);

    await chris.setQuestion(new Question({ text: `There you go bro.`, options: { think: false }, key: `v9VanessaMCChrisBehindBarStayed` })
        .option({ title: `Stay`, key: true })
        .option({ title: `Leave`, key: false }));


    if (Question.globalAnswers.v9VanessaMCChrisBehindBarStayed) {
        return jump(V9VanessaMCChrisBarVanessaWithChris_Stayed, "V9VanessaMCChrisBarVanessaWithChris_Stayed");
    }
    await endReplay();
    return jump(V9VanessaMCChrisBarVanessaWithChris_Left, "V9VanessaMCChrisBarVanessaWithChris_Left");


};
export const V9VanessaMCChrisBarVanessaWithChris_Stayed = async (): Promise<any> => {
    mc.think(`I guess I have it coming...`);
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_12);
    vanessa.talk(`Make sure to get my good side!`);
    ImageClass.setImage(images.v9.V9VanessaChrisBehindBar_14);
    mc.think(`Here I'm taking pictures of Vanessa sucking someone off...`);
    if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
        mc.talk(`Again...`);
        mc.talk(`I feel like I'm gaining experience filming her fucking.`);
    }
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_4);
    mc.think(`Vanessa started licking Chris's shaft up and down.`);
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_7);
    mc.think(`She wrapped the tip of his cock with her mouth pressing and releasing.`);
    chris.talk(`Ah...`);
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_5);
    mc.think(`She continued by taking his cock half way down her throat.`);
    mc.think(`She has experience and she's giving him the full package.`);
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_12);
    mc.think(`She looked at me again like she's gaining pleasure from me just being there.`);
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_1);
    mc.think(`But then again. It wasn't just me. The entire surrounding could see her right now.`);

    ImageClass.setImage(v9.V9VanessaChrisBehindBar_12);
    chris.talk(`Come-on stop teasing you are killing me.`);
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_13);
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {
        chris.talk(`I know from experience that you can do better!`);
    } else {
        chris.talk(`I can bet you can do better!`);
    }

    mc.think(`But Chris wanted more.`);
    doWaitImageByTime(v9.Anim_V9VanessaChrisBehindBarBJ.poster);
    ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBehindBarBJ, { loop: 0 });
    mc.think(`Vanessa got the message and started sucking him faster and deeper.`);
    mc.think(`She then took a big breath and put his entire cock down her throat.`);
    chris.talk(`Fuck!`);


    // FIXME: shadow on shirt
    doWaitImageByTime(v9.V9VanessaChrisBehindBar_16);
    mc.think(`They got up and Vanessa was looking at my straight in the eyes as Chris penetrated her from behind.`);
    doWaitImageByTime(v9.Anim_V9VanessaChrisBehindBarLeaning.poster);
    ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBehindBarLeaning);
    vanessa.talk(`I wasn't completely sure how I felt when Vanessa used me as her support while Chris kept fucking her.`);
    vanessa.talk(`Fuck!`);
    vanessa.talk(`Oh yes! Yes!`);
    vanessa.talk(`Keep going!`);
    ImageClass.setImage(images.v9.V9VanessaChrisBehindBar_20);
    chris.talk(`Ahh!!`);
    ImageClass.setImage(images.v9.V9VanessaChrisBehindBar_21);
    mc.think(`I guess that is it.`);

    if (empty.properties.v8AnnChrisStateCounter.cummc === 0 && Game.seenScenarios.includes("V8AnnChrisHouse")) {
        ImageClass.setImage(images.v9.V9VanessaChrisBehindBar_23);
        chris.talk(`I owe you one bro.`);
        ImageClass.setImage(images.v9.V9VanessaChrisBehindBar_22);
        mc.talk(`For what?`);
        ImageClass.setImage(images.v9.V9VanessaChrisBehindBar_23);
        chris.talk(`you know... For being cool with this and all.`);
    }

    doWaitImageByTime(images.v9.V9VanessaChrisBehindBar_24);
    vanessa.talk(`Oh look! You made a mess!`);
    chris.talk(`Sorry...`);
    vanessa.talk(`Come one ${mc.name}, let's get out of here.`);
    await endReplay(replayScenesList.V9VanessaMCChrisBarVanessaWithChris);
    return jump(V9VanessaMCChrisBarEnd, "V9VanessaMCChrisBarEnd");
};
export const V9VanessaMCChrisBarVanessaWithChris_Left = async (): Promise<any> => {
    doWaitImageByTime(v9.V9BarMorning_44);
    mc.think(`What the fuck was she thinking? No way I'm going to take photos while she sucks someone off.`);
    if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
        mc.think(`Again...`);
        if (isJoeEnemy()) {
            mc.think(`I mean... Joey is my friend.`);
        } else {
            mc.think(`I mean... Joey was my friend.`);
        }
    }
    mc.think(`Well. Nothing else I can do now but wait.`);

    return jump(V9VanessaMCChrisBar_WaitForVanessa, "V9VanessaMCChrisBar_WaitForVanessa");
};
export const V9VanessaMCChrisBarJoinKim = async (): Promise<any> => {
    empty.think(``, { style: { overlay: false }, wait: false });
    doTransition(v9.V9BarToilet_28);
    mc.think(`Ah shit, here we go again.`);
    doWaitImageByTime(v9.V9BarToilet_29);
    mc.think(`Woah!`);
    doWaitImageByTime(v9.V9BarToilet_1);

    kim.talk(`I wasn't sure if you are going to show up.`);
    mc.think(`Oh shit. Vanessa was right.`);

    doWaitImageByTime(v9.V9BarToilet_2);
    kim.talk(`But I'm glad you did.`);
    doWaitImageByTime(v9.V9BarToilet_3);
    mc.think(`Woah, she acts like a totally different girl now. Where did that come from?`);
    doWaitImageByTime(images.v9.V9BarToilet_6);
    mc.think(`Kim turned around showing me her back.`);
    doWaitImageByTime(images.v9.V9BarToilet_7);
    mc.think(`She grabbed her dress as she was about to lift it up.`);
    doWaitImageByTime(images.v9.V9BarToilet_8);
    mc.think(`Oh damn... She has a really great ass!`);
    doWaitImageByTime(images.v9.V9BarToilet_9);
    mc.think(`I set there for a moment admiring it.`);
    doWaitImageByTime(images.v9.V9BarToilet_10);
    mc.think(`She moved her body closer to my face, waiting for me to eat it.`);
    doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletAloneLick);
    ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletAloneLick);
    mc.think(`I didn't hesitate at all.`);
    mc.think(`An extremely sexy girl pushing herself against my face?`);
    mc.think(`Of course I'm going to dig in.`);
    kim.talk(`Ahh...`);
    doWaitImageByTime(v9.V9BarToilet_12);
    mc.think(`Kim used her arms to keep pushing harder and harder against my face.`);
    doWaitImageByTime(v9.V9BarToilet_13);
    mc.think(`She knew what she wants me to do and wasn't shy at it at all.`);
    doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletAloneBJ);
    ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletAloneBJ);
    mc.think(`She kneeled before me and took my dick into her mouth.`);
    mc.think(`And damn... She knows how to suck a cock.`);
    mc.think(`She kept sucking while keeping steady rhythm without needing to take a breath. And god. It felt good.`);

    if (Game.isReplayRunning?.ID === "V9VanessaMCChrisBarJoinKimVanessa" || Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "funWithKimTogether" || Question.globalAnswers.v9VanessaMCChrisBarWatchedVanessaChris === false) {
        mc.think(`I hear footsteps...`);
        ImageClass.setImage(images.v9.V9BarToilet_24);
        vanessa.talk(`I knew it!`);
        ImageClass.setImage(images.v9.V9BarToilet_25);
        vanessa.talk(`Having fun?`);
        ImageClass.setImage(images.v9.V9BarToilet_26);
        mc.think(`At first I though that Vanessa might scare Kim away.`);
        mc.think(`But she didn't move.`);
        mc.think(`She looked back at Vanessa without saying a word.`);
        doWaitImageByTime(images.v9.V9BarToilet_27);
        vanessa.talk(`Don't let it go soft.`);
        return jump(V9VanessaMCChrisBarJoinKim_VanessaOptions, "V9VanessaMCChrisBarJoinKim_VanessaOptions");

    } else {
        doWaitImageByTime(v9.V9BarToilet_14);
        mc.think(`Kim stood up and got on top of me.`);
        doWaitImageByTime(v9.V9BarToilet_15);
        mc.think(`Her pussy feels so nice and tight.`);
        doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletFuckAlone.poster);
        ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletFuckAlone);
        mc.think(`I started bouncing her up and down filling her entire vagina.`);
        mc.think(`The excitement of fucking a stranger is bringing me to climax faster than I expected.`);
        doWaitImageByTime(v9.V9BarToilet_17);
        doWaitImageByTime(v9.V9BarToilet_18);
        mc.talk(`Fuck.`);
        doWaitImageByTime(v9.V9BarToilet_20);
        mc.think(`Kim got down and grabbed me cock.`);
        doWaitImageByTime(v9.V9BarToilet_19);
        mc.think(`You better get back to your friend, she must be worried sick.`);
        mc.think(`Where Does Chris find these girls?`);
    }

    await endReplay(replayScenesList.V9VanessaMCChrisBarJoinKim);
    return jump(V9VanessaMCChrisBarJoinKim_End, "V9VanessaMCChrisBarJoinKim_End");
};
export const V9VanessaMCChrisBarJoinKim_VanessaOptions = async (): Promise<any> => {
    let questionText = ``;
    if (!Game.seenScenarios.includes(`V9VanessaMCChrisBarJoinKim_VanessaOptions`)) {
        doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletBJGirl);
        ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletBJGirl);
        mc.think(`Fuck!`);
        mc.think(`Vanessa kneeled down next to Kim and started licking my cock as Kim was taking it in.`);
        questionText = `The feeling of two tongues pleasuring my cock is unreal.`;
        mc.think(questionText);

    }


    await mc.setQuestion(new Question({ text: questionText, options: { think: true }, key: `v9VanessaMCChrisBarKimThreesomeOptions` })
        .option({ title: empty.properties.v9VanessaMCChrisBarKimThreesomeState === "bjVanessa" ? "Put Kim back down" : `Fuck Kim`, key: `fuckKim`, hide: (Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "fuckKim" || !Game.seenScenarios.includes(`V9VanessaMCChrisBarJoinKim_VanessaOptions`)) })
        .option({ title: `Both licking`, key: `bjBoth`, hide: Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjBoth" })
        .option({ title: `Blowjob from Vanessa Kim Licking`, key: `bjBothVanessa`, show: Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjBothKim" || Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjBoth" || !Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions })
        .option({ title: `Blowjob from Kim Vanessa licking`, key: `bjBothKim`, show: Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjBoth" || Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjBothVanessa" })
        .option({ title: `Blowjob from Vanessa`, key: `bjVanessa`, show: Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "fuckKim" })
        .option({ title: `Cum`, key: `cum`, show: empty.properties.v9VanessaMCChrisBarKimThreesomeState === "fuckKim" || empty.properties.v9VanessaMCChrisBarKimThreesomeState === "bjVanessa" }));


    if (Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "fuckKim") {
        if (empty.properties.v9VanessaMCChrisBarKimThreesomeOptions.fuckKim && empty.properties.v9VanessaMCChrisBarKimThreesomeState === "bjVanessa") {

            ImageClass.setAnimations([
                { ...images.v9.Anim_V9VanessaChrisBarToiletFuckTransition, options: { loop: 1 } },
                { ...images.v9.Anim_V9VanessaChrisBarToiletFuck, options: { loop: 999999 } },
            ], { waitForEnd: true, wait: 2 });
            if (empty.properties.v9VanessaMCChrisBarKimThreesomeOptions.fuckKim === 1) {
                mc.think(`Vanessa position the cock right on top of Kim's pussy and it slid right away.`);
                mc.think(`The feeling of switching from mouth to pussy feels amazing.`);

            }
        } else {
            if (empty.properties.v9VanessaMCChrisBarKimThreesomeOptions.fuckKim) {

                doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletFuck.poster);
                ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletFuck);
            } else {
                mc.think(`It was now time to fuck Kim`);
                doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletFuck.poster);
                mc.think(`She raised her dress and got on top of me.`);
                ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletFuck);
                mc.think(`My cock was so wet from having both of them just licking and sucking it.`);
                mc.think(`Damn. Her pussy feels so good.`);

            }

        }

    } else if (Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjBoth") {
        doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletLickingTogether);
        ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletLickingTogether);

    } else if (Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjVanessa") {
        ImageClass.setAnimations([
            { ...images.v9.Anim_V9VanessaChrisBarToiletBJTransition, options: { loop: 1 } },
            { ...images.v9.Anim_V9VanessaChrisBarToiletVanessaBJ, options: { loop: 999999 } },
        ], { wait: 2, waitForEnd: true });

        if (!empty.properties.v9VanessaMCChrisBarKimThreesomeOptions.bjVanessa) {
            mc.think(`I lifted Kim up and Vanessa knew exactly what to do.`);
            mc.think(`My cock was covered with Kim's juice and Vanessa was happy to take it in.`);
        }



    } else if (Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjBothVanessa") {
        doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletTogetherVanessaBJ);
        ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletTogetherVanessaBJ);


    } else if (Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions === "bjBothKim") {
        doWaitImageByTime(v9.Anim_V9VanessaChrisBarToiletBJGirl);
        ImageClass.setAnimation(images.v9.Anim_V9VanessaChrisBarToiletBJGirl);


    } else {
        // cum
        mc.think(`I can't take it anymore! Her pussy is just too good!`);
        doImageShake(v9.V9BarToilet_21);
        mc.think(`Ahh!!!`);
        mc.think(`Vanessa look at my cum dripping from this girl I just met.`);
        doWaitImageByTime(v9.V9BarToilet_22);
        mc.think(`But she kept doing her part.`);
        mc.think(`She put my cock in her mouth licking all the cum.`);
        ImageClass.setImage(images.v9.V9BarToilet_23);
        mc.think(`Fuck!`);
        mc.think(`That's what I call a finale.`);
        await mc.set((properties) => {
            properties.v9MCFuckedKimWithVanessa = true;
        });
        await endReplay(replayScenesList.V9VanessaMCChrisBarJoinKimVanessa);
        return jump(V9VanessaMCChrisBarJoinKim_End, "V9VanessaMCChrisBarJoinKim_End");

    }
    await empty.set((properties) => {
        if (!properties.v9VanessaMCChrisBarKimThreesomeOptions[Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions]) {
            properties.v9VanessaMCChrisBarKimThreesomeOptions[Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions] = 0;

        }
        properties.v9VanessaMCChrisBarKimThreesomeOptions[Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions] += 1;
    });
    await empty.set((properties) => {
        properties.v9VanessaMCChrisBarKimThreesomeState = Question.globalAnswers.v9VanessaMCChrisBarKimThreesomeOptions;
    });
    return jump(V9VanessaMCChrisBarJoinKim_VanessaOptions, "V9VanessaMCChrisBarJoinKim_VanessaOptions");
};
export const V9VanessaMCChrisBarJoinKim_End = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.v9MCFuckedKim = true;
    });
    return jump(V9VanessaMCChrisBarEnd, "V9VanessaMCChrisBarEnd");
};


export const V9VanessaMCChrisBarSitTalk = async (): Promise<any> => {
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`Can't we just sit back and talk?`);
    ImageClass.setImage(images.v9.V9BarMorning_46);
    vanessa.talk(`Oh my god!`);
    vanessa.talk(`You dragged me here just so we could talk?`);
    vanessa.talk(`We could've done it anywhere!`);
    ImageClass.setImage(images.v9.V9BarMorning_47);
    mc.talk(`You were the one insisting of going out.`);
    ImageClass.setImage(images.v9.V9BarMorning_46);
    vanessa.talk(`Sure, but I didn't expect this!`);
    ImageClass.setImage(images.v9.V9BarMorning_47);
    mc.talk(`Tough...`);
    vanessa.talk(`...`);
    ImageClass.setImage(images.v9.V9BarMorning_46);
    vanessa.talk(`What do you want to talk about?`);
    ImageClass.setImage(images.v9.V9BarMorning_50);
    vanessa.talk(`The stock market? Maybe global warming?`);
    ImageClass.setImage(images.v9.V9BarMorning_45);
    vanessa.talk(`Oh! I know! We can talk about how to save dying species.`);

    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`Nah...`);

    mc.talk(`Let's talk about you.`);
    ImageClass.setImage(images.v9.V9BarMorning_47);
    vanessa.talk(`About me?`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`What do you want to know? You already know everything.`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`How did you turn out to be the way you are?`);
    mc.talk(`Obviously you didn't grow up to be this way.`);
    ImageClass.setImage(images.v9.V9BarMorning_46);
    vanessa.talk(`This way?`);
    ImageClass.setImage(images.v9.V9BarMorning_47);
    mc.talk(`A slut?`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`Thank you!`);
    ImageClass.setImage(images.v9.V9BarMorning_43);
    mc.talk(`And your parents seems to be oblivious to everything around them.`);
    mc.talk(`Maybe you can tell me more about that.`);

    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`I'm sure we already had a similar conversation.`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`Not really.`);

    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`Pft...`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`Just ask me a question and I'll do my best to answer.`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`I already did.`);
    mc.talk(`How did you turn out to be the way you are.`);
    mc.talk(`I'm sure there is a story behind that you refuse to talk about.`);
    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`No story. It's just too boring to talk about.`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`Try me.`);
    ImageClass.setImage(images.v9.V9BarMorning_48);
    vanessa.talk(`You are annoying, you know that?`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`There is no way to run.`);
    ImageClass.setImage(images.v9.V9BarMorning_53);
    vanessa.talk(`Fine.`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`So, as you know. I'm only child.`);
    vanessa.talk(`My parents are way over protective of me.`);
    ImageClass.setImage(images.v9.V9BarMorning_53);
    vanessa.talk(`Even since I was little, they try to keep me in their own little bubble.`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`But one thing they forgot... They love to go out and enjoy life.`);
    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`Which is something I never managed to understand honestly!`);
    ImageClass.setImage(images.v9.V9BarMorning_46);
    vanessa.talk(`They love their... Sex life... Ew!`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`But they are doing anything in their power to make sure I won't get exposed to that.`);

    ImageClass.setImage(images.v9.V9BarMorning_50);
    vanessa.talk(`And you can't really prevent something from someone.`);
    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`So every night when they go out I made sure to do my own little research.`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`I wanted to see what's the fuzz is about...`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`And that's how I discovered porn.`);
    vanessa.talk(`And I know that if my parents can live double life, so can I.`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`They behave different around me. So why can't I do the same?`);
    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`I think that's why they go out so much. They want to be themselves.`);
    ImageClass.setImage(images.v9.V9BarMorning_54);
    vanessa.talk(`Now that I think about that. Maybe I'm just a their reflection.`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`That still doesn't explain why you love sex so much.`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`Oh. Because it's fun.`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`And how come you don't care what people think of you?`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`Because my parents are doing anything in their power so the world would see me as their innocent child.`);
    vanessa.talk(`So I guess my mind just said fuck that and went the other way around completely.`);
    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`Like who cares what other people think?`);
    vanessa.talk(`On the one hand, I have my parents thinking I'm this cute little angel.`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`And on the other, I have other people thinking I'm this biggest slut they have ever seen.`);
    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`So who are you really?`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`I'm Vanessa.`);
    ImageClass.setImage(images.v9.V9BarMorning_43);
    mc.talk(`So, you acting like a slut. Is it all an act?`);
    ImageClass.setImage(images.v9.V9BarMorning_42);
    vanessa.talk(`Is it really me the one acting?`);
    ImageClass.setImage(images.v9.V9BarMorning_52);
    vanessa.talk(`You have people running around acting all nice to their boss they hate.`);
    vanessa.talk(`Or people hiding their true desires just because they are afraid what people might think of them.`);
    ImageClass.setImage(images.v9.V9BarMorning_51);
    vanessa.talk(`I'm the truest person there is.`);

    ImageClass.setImage(images.v9.V9BarMorning_49);
    mc.talk(`There is something about that...`);


    chris.talk(`Thank you for guys! I appreciate it.`);

    return jump(V9VanessaMCChrisBarEnd, "V9VanessaMCChrisBarEnd");
};
export const V9VanessaMCChrisBar_WaitForVanessa = async (): Promise<any> => {
    doTransition(v9.V9BarMorning_44);

    mc.think(`They are certainly taking their time...`);
    doWaitImageByTime(v9.V9BarMorning_42);
    vanessa.talk(`So?`, { style: { overlay: true } });
    mc.talk(`So what?`);
    ImageClass.setImage(v9.V9BarMorning_43);
    vanessa.talk(`How was she?`);
    mc.talk(`I have no idea... I was here.`);
    ImageClass.setImage(v9.V9BarMorning_46);
    vanessa.talk(`What the fuck ${mc.name}?`);
    ImageClass.setImage(v9.V9BarMorning_47);
    mc.talk(`Why are you complaining? You got what you want and so did I.`);
    ImageClass.setImage(v9.V9BarMorning_46);
    vanessa.talk(`Really? Is that what you want? Scratching your ass here by yourself? You could have fuck that hottie!`);
    if (Question.globalAnswers.v9VanessaMCChrisBehindBarStayed === false) {
        ImageClass.setImage(images.v9.V9BarMorning_42);
        vanessa.talk(`Or at least stay with me and watch the show.`);
        mc.talk(`Nah. Fuck that.`);
        if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
            ImageClass.setImage(images.v9.V9BarMorning_43);
            mc.talk(`Taking a video of you and Joey was enough for me.`);
            if (Question.globalAnswers.v4SexTapeFuckedVanessa) {
                ImageClass.setImage(images.v9.V9BarMorning_42);
                vanessa.talk(`I didn't hear you complaining when Joe passed out.`);
                ImageClass.setImage(images.v9.V9BarMorning_43);
                mc.talk(`Well. That's already in the past by now.`);
            }
        }

    } else {

        ImageClass.setImage(images.v9.V9BarMorning_47);
        mc.talk(`That's what I decided.`);
        ImageClass.setImage(images.v9.V9BarMorning_42);
        vanessa.talk(`I see. And I'll remember that.`);
        ImageClass.setImage(images.v9.V9BarMorning_43);
        mc.talk(`What do you mean by that?`);
        ImageClass.setImage(images.v9.V9BarMorning_42);
        vanessa.talk(`Don't worry. You'll see.`);
    }





    return jump(V9VanessaMCChrisBarEnd, "V9VanessaMCChrisBarEnd");
};

export const V9VanessaMCChrisBarEnd = async (): Promise<any> => {
    //ImageClass.setImage(images.TODO_IMAGE)
    empty.think(``, { style: { overlay: false }, wait: false });

    if (!Question.globalAnswers.v9VanessaMCChrisBehindBarStayed && !mc.properties.v9MCFuckedKim && !mc.properties.v9MCFuckedKimWithVanessa) {
        doWaitImageByTime(v9.V9BarMorning_55);
        chris.talk(`Thanks for coming guys! I'm going to take a power nap before opening for the evening.`);
    } else {

    }

    return jump(V9VanessaMCChrisBarAfter, "V9VanessaMCChrisBarAfter");
};